import type { DatasetSpace, ExperimentDraftCreateInput } from "@globals";
import { generateNewParameterIDs } from "@lib/experiment/ExperimentConfiguration/parameters/utils/generateNewParameterIDs";

export const createDraftInputFromDatasetSpace = (datasetSpace: DatasetSpace): ExperimentDraftCreateInput => {
  const parameterEntries = (datasetSpace.parameters ?? []).map(sourceParam => {
    const { parameter } = generateNewParameterIDs(sourceParam);
    return { sourceId: sourceParam.id, parameter };
  });

  const measurementEntries = (datasetSpace.measurements ?? []).map(m => ({
    sourceId: m.id,
    measurement: { ...m, id: crypto.randomUUID() }
  }));

  return {
    name: "",
    parameters: parameterEntries.map(e => e.parameter),
    measurements: measurementEntries.map(e => e.measurement),
    historical_datasets: [
      {
        dataset_id: datasetSpace.dataset.id,
        parameter_mappings: parameterEntries.map(({ sourceId, parameter }) => ({
          source_parameter_id: sourceId,
          destination_parameter_id: parameter.id
        })),
        measurement_mappings: measurementEntries.map(({ sourceId, measurement }) => ({
          source_measurement_id: sourceId,
          destination_measurement_id: measurement.id
        }))
      }
    ]
  };
};
